import React, { useEffect } from "react";
import MaintenanceTypeSelect from "../MaintenanceTypeSelect/MaintenanceTypeSelect";
import ParentsMaintenanceItemSelect from "../ParentsMaintenanceItemSelect/ParentsMaintenanceItemSelect";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import ScheduleSelect from "../ScheduleSelect/ScheduleSelect";

export default function MaintenanceItemInputs({ allMaintenanceSchedule,items, isParentElement, standardItem, setItems, setFile, file, handleCategorySelect, maintenanceItem, handleInputChange, setMaintenanceItem }) {
  const { ScheduleId, itemId } = useParams();
  const dispatch = useDispatch();
  const { allStandardMaintenanceItems } = useSelector((state) => state.standardMaintenanceItems);
  const { pathname } = useLocation();

  console.log(standardItem)
  useEffect(() => {
    if (pathname === "/AddMaintenanceItem" || pathname === `/EditMaintenanceItem/${itemId}`) {
      dispatch(getAllStandardMaintenanceItems());
    }
  }, [pathname, dispatch]);

  const handleStatusChange = (e) => {
    const isChecked = e.target.checked;
    const newStatus = isChecked ? "completed" : "pending";
    setItems((prevItems) => prevItems.map((item) => (item.id === maintenanceItem.id ? { ...item, status: newStatus } : item)));
  };


  console.log(standardItem)

  return (
    <>
      <section className={`row text-center ${isParentElement ? "" : "mb-5"}`}>
        <h4>
          <span> بيانات العنصر </span>
        </h4>
        <div className="col-sm-4 mt-3 mb-2">
          <div>
            {!standardItem && <label htmlFor="name">اسم عنصر الصيانة</label>}
            {standardItem && (
              <p className="fs-5 ">
                <span>{standardItem?.standardItem?.name}</span>
                <span className="d-block">الكمية {maintenanceItem?.quantity}</span>
              </p>
            )}
            {!standardItem && <input type="text" name="name" value={maintenanceItem?.name || standardItem?.name || ""} placeholder="اسم عنصر الصيانة" id="name" className="form-control" onChange={handleInputChange} />}
          </div>
        </div>
        {/* {ScheduleId && maintenanceItem?.image !== null && (
          <div className="col-12 mt-3">
            <img className="img-fluid" src={(file?.file && URL.createObjectURL(file?.file)) || maintenanceItem?.image} alt="صورة العنصر" />
          </div>
        )} */}
        {ScheduleId && (
          <div className="col-sm-4 mt-3 mb-2">
            <div className="form-check">
              <div class="checkbox-wrapper-19">
                <input checked={maintenanceItem?.status === "completed"} onChange={handleStatusChange} type="checkbox" id={`status-${maintenanceItem?.id}`} />
                <label htmlFor={`status-${maintenanceItem?.id}`} class="check-box" />
              </div>
              <label className="form-check-label" htmlFor={`status-${maintenanceItem?.id}`}>
                مكتمل (Complete)
              </label>
            </div>
            <small className="text-muted">إذا لم يتم تحديده، ستكون الحالة "Pending" (معلق).</small>
          </div>
        )}
        <div className="col-sm-4 mt-3 mb-2">
          <div>
            {!standardItem && <label htmlFor="name_en">اسم عنصر الصيانة بالانجليزي</label>}
            {standardItem && (
              <p className="fs-5 ">
                <span>{standardItem?.name_en}</span>
              </p>
            )}
            {!standardItem && <input type="text" value={maintenanceItem?.name_en || ""} name="name_en" placeholder="اسم عنصر الصيانة بالانجليزي" id="name_en" className="form-control" onChange={handleInputChange} />}
          </div>
        </div>

        {!ScheduleId && (
          <div className="col-md-6 mt-3">
            <div>
              <MaintenanceTypeSelect maintenanceItem={maintenanceItem} handleCategorySelect={handleCategorySelect} />
            </div>
          </div>
        )}

        {!ScheduleId && (
          <div className="col-md-6 mt-3">
            <div>
              <label htmlFor="duration">وقت الصيانة</label>
              <input type="number" value={maintenanceItem?.estimated_duration || ""} placeholder="وقت الصيانة" id="duration" name="estimated_duration" className="form-control" onChange={handleInputChange} />
            </div>
          </div>
        )}
        {ScheduleId && (
          <div className="col-lg-6 mt-3">
            <label htmlFor="formFile">صورة العنصر</label>
            <input className="form-control" onChange={(e) => setFile({ file: e.target.files[0], id: maintenanceItem.id })} type="file" id="formFile" />
          </div>
        )}
        {ScheduleId && (
          <div className="col-lg-6 mt-3">
            <div>
              <label htmlFor="notes">الملاحظات</label>
              <textarea name="notes" id="notes" value={maintenanceItem?.notes || ""} className="form-control" placeholder="الملاحظات" onChange={(e) => handleInputChange(e, maintenanceItem?.id)} />
            </div>
          </div>
        )}

        {!ScheduleId && (
          <div className="col-12">
            <label htmlFor="description">وصف العنصر</label>
            <textarea name="description" id="description" value={maintenanceItem?.description || ""} className="form-control" placeholder="وصف العنصر" onChange={handleInputChange} />
          </div>
        )}
      </section>
      {!isParentElement && (
        <section className="row">
          <h4>
            <span> ربط العنصر </span>
          </h4>
          <div className="col-md-6 mt-3">
            <label htmlFor="parent">
              {" "}
              تابع لعنصر <span className="text-200 fs-6 ms-3"> ( في حالة أنه عنصر غير رئيسي ) </span>{" "}
            </label>
            <ParentsMaintenanceItemSelect maintenanceItem={maintenanceItem} setMaintenanceItem={setMaintenanceItem} allStandardMaintenanceItems={allStandardMaintenanceItems} />
          </div>
          {/* <div className="col-md-6 mt-3">
            <ScheduleSelect setMaintenanceItem={setMaintenanceItem} allMaintenanceSchedule={allMaintenanceSchedule} />
          </div> */}
        </section>
      )}
    </>
  );
}
